import type { AxiosError } from 'axios';
import type { AuthError as AmplifyAuthError } from 'aws-amplify/auth';

import { ErrorHandler, type AppError } from './error-handler';
import { DependencyManager } from './dependency-manager';

export interface RequestResult<T> {
  success: boolean;
  error?: AppError;
  response?: T;
};

export async function handleRequest<T>(action: () => Promise<T>): Promise<RequestResult<T>> {
  try {
    const response = await action();

    console.log('handleRequest#success', { success: true, response: response });
    return {
      success: true,
      response: response
    };
  } catch (error) {
    const appError = ErrorHandler.processError(error as AxiosError | AmplifyAuthError | Error);

    // Delegate all other exception handling to the app
    if (DependencyManager.requestHandler.onError) {
      await DependencyManager.requestHandler.onError(appError);
    }

    console.error(appError.toString());
    return {
      success: false,
      error: appError
    };
  }
};
